module.exports = __webpack_public_path__ + "img/infra.79b1141.svg";